import { render } from "./CategoriesFloatingButton.vue?vue&type=template&id=71cf8415"
import script from "./CategoriesFloatingButton.vue?vue&type=script&lang=js"
export * from "./CategoriesFloatingButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__